import { render, staticRenderFns } from "./OptionsProp.vue?vue&type=template&id=07c87aee&scoped=true&"
import script from "./OptionsProp.vue?vue&type=script&lang=js&"
export * from "./OptionsProp.vue?vue&type=script&lang=js&"
import style0 from "./OptionsProp.vue?vue&type=style&index=0&id=07c87aee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c87aee",
  null
  
)

export default component.exports